import { useContext } from "@nuxtjs/composition-api";

export function useFetchProfessionals(context) {
  const { $query } = context || useContext();

  return async ({
    professionSeoName,
    professionTaskSeoName,
    citySeoName,
    personIds,
    page = 1,
    pageSize = 10,
  }) => {
    const PROFESSIONALS = await import("./professionals.graphql");

    const res = await $query(PROFESSIONALS, {
      professionSeoName,
      professionTaskSeoName,
      citySeoName,
      personIds,
      page,
      pageSize,
    });

    return res.professionals;
  };
}
